import '../chart_view.js.coffee';# Added by Script 
Monitoring.Views.Charts ||= {}

class Monitoring.Views.Charts.FbCommentsRankingChartView extends Monitoring.Views.Charts.ChartView

  className: 'processing item w2 h2 posts-chart'
  defaultSize: 'w2'
  template: JST['backbone/templates/monitoring/charts/posts_chart']
  url: "/monitoring/api/charts/fb_post_ranking"

  events:
    'click #close_chart': 'destroy'
    'click #save_note': 'saveNote'
    'click #delete_note': 'deleteNote'
    'click .insert-note': 'displayNote'

  initialize: (@options = {}) ->
    @searchQuery = @options.searchQuery
    @facets = @options.facets
    @_settings = @options.settings
    @container = @options.container
    @title = I18n.t('monitoring.dashboard.charts.fb_posts_ranking.title')
    @postWidgets = []

  render: ->
    @$el.html(@template({title: @title}))
    @

  afterAppend: ->
    @ajaxCall(@url, @getSearchQuery().toJSON(), (response) =>
      @$el.removeClass('processing')
      @postWidgets = response.map((serializedPost) => @addPostWidgetWith(serializedPost))
      @trigger('masonry')
    )

  addPostWidgetWith: (serializedPost) ->
    properties = serializedPost.specification
    vueComponentName = if serializedPost.social_content_exists then 'facebook-post-widget' else 'facebook-empty-post-widget'

    widget = new VueInBackbone.VueComponent(vueComponentName, properties)
    @addPostWidget(widget)
    widget.render()

  addPostWidget: (postWidget) ->
    @vueContainer().append(postWidget.el)

  vueContainer: ->
    @$el.find('#posts_chart')

  getSearchQuery: ->
    query = @searchQuery.deepCopy()
    query.set('dimension', 'parent_post_id')
    query

  destroy: ->
    @postWidgets.forEach((postWidget) => postWidget.remove())
    super()
